module.exports = __webpack_public_path__ + "static/media/controlpanel.f3727f96.jpg";